import styled from "@emotion/styled";

// Client container
export const ClientContainer = styled.div`
  display: grid;
  cursor: pointer;
  padding: 1rem;
  border-radius: 10px;
  transition: all 200ms ease;

  &:hover {
    // box-shadow: 0 0 20px 4px #e3e6ec;
    transform: scale(1.04);
  }
`;

export const H1 = styled.h1`
  margin-bottom: 1rem;
`;
export const Span = styled.span``;

export const ProgressBarContainer = styled.div`
  height: 1rem;
  margin: 1rem 0;
`;
